import styled from 'styled-components';

export const UiLoginBox = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
`;
